
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LoginComponent } from '@siat-fe/auth';
import { CustomModalOptions, SmartModalService } from '@siat-fe/shared';

@Component({
   
  templateUrl: './welcome-page.component.html',
  imports: [MatButtonModule, TranslatePipe],
})
export class WelcomePageComponent implements OnInit {
  /**
   * Smart dialog service.
   */
  smartDialogService = inject(SmartModalService);

  /**
   * The activated route.
   */
  activatedRoute = inject(ActivatedRoute);

  /**
   * Indicates if the session is expired.
   */
  areSessionExpired = false;

  /**
   * Error returned after an unsuccessful Entra login.
   */
  authError: 'permissions' | 'generic' | null = null;

  /**
   * @inheritdoc
   */
  ngOnInit(): void {
    this.areSessionExpired =
      this.activatedRoute.snapshot.queryParams['sessionExpired'];
    const authError = this.activatedRoute.snapshot.queryParams['authError'];
    this.authError =
      authError === 'permissions' || authError === 'generic'
        ? authError
        : null;
  }

  openLoginDialog(): void {
    this.smartDialogService.openModalFromComponent(LoginComponent, {
      config: {
        disableClose: true,
      },
    } as CustomModalOptions);
  }
}
